import Api from '@/services/Api'

export default {
 getVaccines () {
   return Api().get("/vaccines");
},
  updateVaccine (params) {
    return Api().put("/vaccines",params);
  },
  addVaccine (params) {
    return Api().post("/vaccines",params);
  },
  getVaccine (params) {
    return Api().get("/vaccines/"+params);
  },
  deleteVaccine(params) {
    return Api().delete("/vaccines/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/VaccineService.js